
import { defineComponent, computed } from 'vue';
import { VueDraggableNext } from 'vue-draggable-next';

export default defineComponent({
    emits: ['callback'],
    components: {
        draggable: VueDraggableNext
    },
    props: ['items', 'isHiddenCheckboxVisible'],
    data(props) {
        return {
            list: props.items || [],
            isCheckboxVisible: props.isHiddenCheckboxVisible || false,
            isDragging: false
        };
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: 'description',
                disabled: false,
                ghostClass: 'ghost'
            };
        }
    },
    methods: {
        callback() {
            this.$emit('callback', this.list);
        },
        sortAsc: function() {
            return this.list.slice().sort(function(a: { order: number }, b: { order: number }) {
                return a.order - b.order;
            });
        },
        isSelected(currentIdx: number, itemOrderIdx: number) {
            return Number(itemOrderIdx) === Number(currentIdx) ? true : false;
        },
        isActive(isHidden: boolean) {
            return isHidden ? true : false;
        },
        resetOrder() {
            for (const idx in this.list) {
                this.list[idx]['order'] = Number(idx) + 1;
            }
        },
        onCustomValueChange(currentIndex: string, event: any) {
            const idx = Number(currentIndex) - 1;
            this.list[idx]['customValue'] = event.target.value;
            this.finalProcess();
        },
        onSortChange(currentIndex: string, event: any) {
            const oIdx = Number(currentIndex) - 1;
            const nIdx = Number(event.target.value) - 1;
            const itemData = this.list[oIdx];

            // Check to see if nIdx is after a hidden (disabled) element
            if (this.onSortCheck(nIdx)) {
                this.forceNewIdx(oIdx, nIdx, itemData);
            } else {
                this.findNewIdx(oIdx, itemData);
            }
        },
        onDrop() {
            this.finalProcess();
        },
        onCheckBoxChange(id: string, event: any) {
            const itemIdx = this.list.findIndex((x: { id: { toString: () => any } }) => x.id.toString() === id.toString());
            if (itemIdx !== -1) {
                const itemData = this.list[itemIdx];
                itemData.isHidden = !event.target.checked ? true : false;
                this.findNewIdx(itemIdx, itemData);
            }
        },
        forceNewIdx(oIdx: number, nIdx: number, itemData: any) {
            this.list.splice(oIdx, 1);
            this.list.splice(nIdx, 0, itemData);
            this.finalProcess();
        },
        findNewIdx(oIdx: number, itemData: any) {
            this.list.splice(oIdx, 1);
            if (itemData.isHidden) {
                // Insert item (append)
                this.list.splice(this.list.length, 0, itemData);
            } else {
                const newIdx = this.list.findIndex((x: { isHidden: boolean }) => x.isHidden === true);
                if (newIdx === -1) {
                    // Insert item (append)
                    this.list.splice(this.list.length, 0, itemData);
                } else {
                    // Insert item
                    this.list.splice(newIdx, 0, itemData);
                }
            }

            this.finalProcess();
        },
        onSortCheck(nIdx: number): boolean {
            const foundHiddenIdx = this.list.findIndex((x: { isHidden: boolean }) => x.isHidden === true);
            if (nIdx >= foundHiddenIdx && foundHiddenIdx !== -1) {
                return false;
            }
            return true;
        },
        onMoveCheck(event: any): boolean {
            // Disabled elements will always be at the bottom.
            // If dragged element is moved pass an element that is isHidden, revert move
            if (event.relatedContext.element.isHidden) {
                return false;
            }
            return true;
        },
        finalProcess() {
            this.resetOrder();
            this.sortAsc();
            this.callback();
        }
    }
});
